import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('treads_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('treads_token');
      localStorage.removeItem('treads_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

export const authApi = {
  login: (username, password) => api.post('/auth/login', { username, password }),
  me: () => api.get('/auth/me'),
  logout: () => api.post('/auth/logout')
};

export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getMissedCalls: (start, end) => api.get('/dashboard/missed-calls', { params: { start, end } }),
  getAgentDetail: (agent, params) => api.get(`/dashboard/agent-detail/${agent}`, { params }),
  getOutboundDetail: (extension, params) => api.get(`/dashboard/outbound-detail/${extension}`, { params })
};

export const monitorApi = {
  getAgents: () => api.get('/monitor/agents')
};
